import { render } from "./InterfaceSnackbarContainer.vue?vue&type=template&id=11448969&scoped=true"
import script from "./InterfaceSnackbarContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceSnackbarContainer.vue?vue&type=script&lang=js"

import "./InterfaceSnackbarContainer.vue?vue&type=style&index=0&id=11448969&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11448969"]])

export default __exports__